import { render, staticRenderFns } from "./DefaultInputFields.vue?vue&type=template&id=72d484bf&scoped=true&"
import script from "./DefaultInputFields.vue?vue&type=script&lang=ts&"
export * from "./DefaultInputFields.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultInputFields.vue?vue&type=style&index=0&id=72d484bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d484bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
